import { JobSummaryAdjustment } from './JobSummaryAdjustment';

const EndOfDay = (props) => {
  return <JobSummaryAdjustment {...props} />;
};

export default EndOfDay;
